/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */
export enum BookingHistoryActionEnum {
    Edit = 'EDIT',
    Duplicated = 'DUPLICATED',
    Lock = 'LOCK',
    Unlock = 'UNLOCK',
    Confirmation = 'CONFIRMATION',
    ConfirmationAccepted = 'CONFIRMATION_ACCEPTED',
    DataRequest = 'DATA_REQUEST',
    DataRequestAccepted = 'DATA_REQUEST_ACCEPTED',
    Linked = 'LINKED',
    Revert = 'REVERT',
    RevertConfirm = 'REVERT_CONFIRM',
    Archived = 'ARCHIVED',
    Cancelled = 'CANCELLED'
}



